import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import get from 'lodash/get';
import NiotaClassicApiService from '../../../../services/niotaClassicApiService';
export default {
  name: 'NiotaClassicDevicesDeviceDetailsDownlinksActility',
  props: {
    deviceData: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      downlink: [],
      payload: null,
      port: null,
      menu: false,
      confirmed: false,
      flushQueue: false,
      sendingDownlink: false,
      millisecondsDelay: 1000,
      fcnt: null
    };
  },
  computed: _objectSpread({}, mapState('app', ['color'])),
  watch: {},
  methods: {
    onValueChange: function onValueChange(value, item) {
      this[item] = value;
      this.downlink[item] = value;
    },
    isReadyForSend: function isReadyForSend() {
      return this.payload && this.port;
    },
    sendDownlink: function sendDownlink() {
      var _this = this;

      this.fcnt = null;
      this.sendingDownlink = true;
      this.downlink = [{
        payload: this.payload,
        port: this.port,
        confirmed: this.confirmed,
        flushQueue: this.flushQueue
      }];
      NiotaClassicApiService.deviceSendDownlinkToActility(this.deviceData.id, this.downlink).then(function (res) {
        _this.fcnt = get(res, 'data.sentPacket.fcnt');
        return new Promise(function (resolve) {
          return setTimeout(resolve, _this.millisecondsDelay);
        });
      }).then(function () {
        _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.sentDownlink'), 'success');
      }).finally(function () {
        _this.sendingDownlink = false;
      }).catch(function (error) {
        var apiError = get(error, 'response.data.err');

        _this.$snack(apiError || _this.$i18n_t('NiotaClassic.Devices.snacks.failedDownlink'), 'error');
      });
    }
  }
};